export default __webpack_public_path__ + "static/media/KIR.f99d3a13.svg";